import {ActionsTypes} from './redux-store';

let initialState: any = {}

const sidebarReducer = (state = initialState, action: ActionsTypes) => {

    return state;
}

export default sidebarReducer;